import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import Permissioned from 'dashboard/components/Permissioned';
import { formatAddress, formatDate } from 'dashboard/lib/utils/formatters';
import { ProfileInput } from 'dashboard/models/report/profile';
import Attribute, { AttributeGrid } from 'design-system/components/Attribute';
import { Permission } from 'lib/permissions';

export const ProfileInputDetails = ({ input }: { input: ProfileInput }) => {
  const {
    'name-first': nameFirst,
    'name-last': nameLast,
    birthdate: birthdate,
    'social-security-number': socialSecurityNumber,
    'address-street-1': addressStreet1,
    'address-street-2': addressStreet2,
    'address-city': addressCity,
    'address-subdivision': addressSubdivision,
    'address-postal-code': addressPostalCode,
    'phone-number': phoneNumber,
    'country-code': countryCode,
  } = input;
  const truncatedSSN = socialSecurityNumber?.substring(socialSecurityNumber?.length - 4);

  return (
    <StyledAttributeGrid>
      {nameFirst && (
        <Attribute label='First Name' value={nameFirst} placeholder='N/A' horizontal={true} />
      )}
      {nameLast && (
        <Attribute label='Last Name' value={nameLast} placeholder='N/A' horizontal={true} />
      )}
      {birthdate && (
        <Attribute
          label='Birthdate'
          value={formatDate(birthdate)}
          placeholder='N/A'
          horizontal={true}
        />
      )}
      {phoneNumber && (
        <Attribute label='Phone number' value={phoneNumber} placeholder='N/A' horizontal={true} />
      )}
      {addressStreet1 && (
        <Attribute
          label='Address'
          value={formatAddress({
            addressStreet1,
            addressStreet2,
            addressCity,
            addressSubdivision,
            addressPostalCode,
            countryCode,
            color: 'primary',
          })}
          placeholder='N/A'
          horizontal={true}
        />
      )}
      {socialSecurityNumber && (
        <Permissioned
          permission={Permission.ReportSsnView}
          fallback={
            <Attribute label='SSN' value={truncatedSSN} toggleable={true} placeholder='SSN' />
          }
        >
          <Attribute
            label='SSN'
            value={socialSecurityNumber}
            toggleable={true}
            placeholder='N/A'
            horizontal={true}
          />
        </Permissioned>
      )}
    </StyledAttributeGrid>
  );
};

const StyledAttributeGrid = styled(AttributeGrid)`
  gap: ${Spacing[2]};

  & dt {
    width: 100px;
  }
`;
